/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Responsive modal/panel sync for Requirements page breakpoints.
 * @module utils/requirements/responsivePanelSync
 */

const DESKTOP_BREAKPOINT = 1101;
const TABLET_MAX_BREAKPOINT = 1100;

const syncPanelForWidth = ({
  width,
  showView,
  modalOpen,
  setShowView,
  setModalOpen,
}) => {
  if (showView && width >= DESKTOP_BREAKPOINT) {
    setShowView(false);
    setModalOpen(true);
  } else if (modalOpen && width <= TABLET_MAX_BREAKPOINT) {
    setModalOpen(false);
    setShowView(true);
  } else {
    // No view/modal switch needed for current width.
  }
};

export const getRequirementsViewportFlags = (width) => ({
  isDesktop: width >= DESKTOP_BREAKPOINT,
  isTablet: width >= 768 && width <= TABLET_MAX_BREAKPOINT,
  isMediumMobile: width >= 481 && width <= 767,
  isSmallMobile: width < 481,
});

export const syncRequirementsResponsivePanels = ({
  width,
  showRequirementCreation,
  createModalOpen,
  showRequirementDetails,
  displayModalOpen,
  showProposalsList,
  proposalsModalOpen,
  setShowRequirementCreation,
  setCreateModalOpen,
  setShowRequirementDetails,
  setDisplayModalOpen,
  setShowProposalsList,
  setProposalsModalOpen,
}) => {
  syncPanelForWidth({
    width,
    showView: showRequirementCreation,
    modalOpen: createModalOpen,
    setShowView: setShowRequirementCreation,
    setModalOpen: setCreateModalOpen,
  });
  syncPanelForWidth({
    width,
    showView: showRequirementDetails,
    modalOpen: displayModalOpen,
    setShowView: setShowRequirementDetails,
    setModalOpen: setDisplayModalOpen,
  });
  syncPanelForWidth({
    width,
    showView: showProposalsList,
    modalOpen: proposalsModalOpen,
    setShowView: setShowProposalsList,
    setModalOpen: setProposalsModalOpen,
  });
};

export const shouldUseRequirementsMobileView = ({
  isTablet,
  isMediumMobile,
  isSmallMobile,
}) => isTablet || isMediumMobile || isSmallMobile;
